/**
 * Kalkulator suchej masy (DM) — migrated z assets/js/. Logika obliczeń nietknięta.
 * Markup: inc/hn-dry-matter-calculator.php (shortcode [hn_dry_matter_calculator]).
 */
export function initDryMatter() {
  if (!document.getElementById("hnForm")) return;
  const $ = (id) => document.getElementById(id);

  // ====== INPUTY (muszą istnieć w HTML) ======
  const f = {
    analyticText: $("analyticText"),
    btnLoadAnalytic: $("btnLoadAnalytic"),

    lifeStage: $("lifeStage"),
    protein: $("protein"),
    fat: $("fat"),
    fiber: $("fiber"),
    ash: $("ash"),
    moisture: $("moisture"),
    calcium: $("calcium"),
    phosphorus: $("phosphorus"),

    // opcjonalne pole "zwykły skład" (jeśli dodasz w HTML)
    ingredientsText: $("ingredientsText"),
  };

  // ====== OUTPUT ======
  const out = {
    dm: $("dmVal"),
    protein: $("proteinDmVal"),
    fat: $("fatDmVal"),
    fiber: $("fiberDmVal"),
    carbs: $("carbDmVal"),
    kcal: $("kcalVal"),
    calcium: $("calciumDmVal"),
    phosphorus: $("phosphorusDmVal"),
    cap: $("capRatioVal"),
    badges: $("badges"),

    alertsAnalytic: $("alertsAnalytic"),
    alertsIngredients: $("alertsIngredients"),
  };

  // Jeśli shortcode jest na stronie, ale jakieś elementy nie istnieją (np. ktoś zmienił HTML),
  // to nie wywalaj całego frontu. `btnLoadAnalytic` jest opcjonalny (zostawiamy zgodność wsteczną
  // — od refaktoru UX 2026-06-01 jest jeden bottom button `btnCalc` zamiast dwóch per-panelowych).
  const requiredDomIds = [
    "hnForm",
    "btnCalc",
    "btnClear",
    "lifeStage",
    "protein",
    "fat",
    "fiber",
    "ash",
    "moisture",
    "badges",
    "alertsAnalytic",
    "alertsIngredients",
  ];
  for (const id of requiredDomIds) {
    if (!$(id)) return;
  }

  // ====== HELPERS ======
  const pct = (n) => `${n.toFixed(1)}%`;
  const kcalFmt = (n) => `${Math.round(n)} kcal/100g`;

  function toNumber(v) {
    if (v === undefined || v === null) return null;
    v = String(v).trim();
    if (!v) return null;
    v = v.replace(/\s/g, "");
    v = v.replace(",", ".");
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : null;
  }

  function setValueIfExists(el, value) {
    if (!el) return;
    el.value = value;
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function clearInvalid() {
    const inputs = document.querySelectorAll("#hnForm .hn-input");
    inputs.forEach((el) => el.classList.remove("hn-invalid", "hn-attention"));
  }

  /**
   * Prowadzi do pola skladu. Samo ostrzezenie nie wystarcza, bo pole siedzi
   * w zwinietym <details> "Dodatkowe dane" i uzytkownik go nie widzi.
   */
  function pointToIngredients() {
    const el = f.ingredientsText;
    if (!el) return;
    const details = el.closest("details");
    if (details && !details.open) details.open = true;
    // Skład jest opcjonalny, więc NIE uzywamy hn-invalid (czerwien = blad).
    // hn-attention tylko przyciaga wzrok do pola.
    el.classList.add("hn-attention");
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.focus({ preventScroll: true });
  }

  function markInvalid(el) {
    if (!el) return;
    el.classList.add("hn-invalid");
  }

  function clearUI() {
    out.dm.textContent = "–";
    out.protein.textContent = "–";
    out.fat.textContent = "–";
    out.fiber.textContent = "–";
    out.carbs.textContent = "–";
    out.kcal.textContent = "–";
    out.calcium.textContent = "–";
    out.phosphorus.textContent = "–";
    out.cap.textContent = "–";
    out.badges.innerHTML = "";
    out.alertsAnalytic.innerHTML = "";
    out.alertsIngredients.innerHTML = "";
    clearInvalid();
  }

  function badge(type, text) {
    const s = document.createElement("span");
    s.className = "hn-badge " + type;
    s.textContent = text;
    out.badges.appendChild(s);
  }

  function alertBox(targetEl, type, text) {
    if (!targetEl) return;
    const d = document.createElement("div");
    d.className = "hn-alert " + type;
    d.textContent = text;
    targetEl.appendChild(d);
  }

  function alertAnalytic(type, text) {
    alertBox(out.alertsAnalytic, type, text);
  }

  function alertIngredients(type, text) {
    alertBox(out.alertsIngredients, type, text);
  }

  function getThresholds(stage, moisture) {
    const isWet = moisture >= 60;

    // Progi ME kcal/100g (szacunek) - orientacyjne
    const kcal = {
      adult: { wet: { low: 85, high: 130 }, dry: { low: 330, high: 420 } },
      puppy: { wet: { low: 95, high: 150 }, dry: { low: 360, high: 450 } },
    };

    // Ca:P widełki dopasowane do opisu na stronie:
    //   dorosły ideał 1,2:1-1,5:1, szczeniak 1,0:1-1,4:1 (okMin/okMax).
    //   warnMin/warnMax = jeszcze akceptowalne (poza tym "bad").
    const cap = {
      adult: { okMin: 1.2, okMax: 1.5, warnMin: 1.0, warnMax: 2.0 },
      puppy: { okMin: 1.0, okMax: 1.4, warnMin: 1.0, warnMax: 1.8 },
    };

    return {
      isWet,
      kcal: (stage === "puppy" ? kcal.puppy : kcal.adult)[isWet ? "wet" : "dry"],
      cap: (stage === "puppy" ? cap.puppy : cap.adult),
    };
  }

function normalizeAnalyticText(txt) {
  return String(txt || "")
    .toLowerCase()
    // ujednolicenie separatorów
    .replace(/\r\n/g, "\n")
    .replace(/[;•]+/g, ",")
    .replace(/\n+/g, ",")
    // ujednolicenie dwukropków
    .replace(/:/g, " ")
    // ujednolicenie nawiasów (żeby "białko (11,9%)" też działało)
    .replace(/[()]/g, " ")
    // wielokrotne spacje
    .replace(/\s+/g, " ")
    .trim();
}
function parsePercentFromToken(token) {
  // łapie: 9,7% | 9.7% | 9,7 % | 9.7 %
  const m = token.match(/(\d+(?:[.,]\d+)?)\s*%/);
  if (!m) return null;
  const v = parseFloat(m[1].replace(",", "."));
  return Number.isFinite(v) ? v : null;
}

function detectAnalyticKey(token) {
  const t = token;

  // wilgotność
  if (/(wilgotn|moisture)/.test(t)) return "moisture";

  // białko
  if (/(bia[lł]ko|protein)/.test(t)) return "protein";

  // tłuszcz
  if (/(t[lł]uszcz|fat)/.test(t)) return "fat";

  // włókno
  if (/(w[lł][oó]kno|fiber|fibre)/.test(t)) return "fiber";

  // popiół
  if (/(popi[oó][lł]|ash)/.test(t)) return "ash";

  // wapń
  if (/(wap[ńn]|calcium|\bca\b)/.test(t)) return "calcium";

  // fosfor
  if (/(fosfor|phosphor|\bp\b)/.test(t)) return "phosphorus";

  return null;
}


  // ====== PARSOWANIE "SKŁADU ANALITYCZNEGO" ======
  // Obsługuje:
  // - "białko surowe (11,9%); tłuszcz surowy (5,4%); ..."
  // - "Białko 15,5% tłuszcz 5,9% ..."
  // - "Wapń: 0,30%; Fosfor: 0,25%"
function parseAnalyticText(raw) {
  if (!raw) return {};

  // normalizacja: małe litery, ujednolicenie separatorów
  let t = String(raw)
    .toLowerCase()
    .replace(/\r/g, "\n");

  // zamień średniki na przecinki żeby ujednolicić
  t = t.replace(/;/g, ",");

  // nie dzielimy na linie na sztywno, tylko szukamy par "etykieta + liczba"
  // ważne: liczba dopuszcza przecinek lub kropkę.
  // Etykiety sa tolerancyjne na brak polskich znakow i literowki w diakrytykach
  // ("popiol", "popiól", "bialko"), bo ludzie wklejaja z PDF-ow i etykiet OCR-owanych.
  const grab = (patterns) => {
    for (const re of patterns) {
      const m = t.match(re);
      if (m && m[1]) {
        const v = m[1].replace(",", "."); // 10,4 -> 10.4
        const n = parseFloat(v);
        if (!Number.isNaN(n)) return n;
      }
    }
    return null;
  };

  // Budujemy regexy tak, żeby:
  // - łapały "białko 10,4%" albo "białko: 10,4%" albo "białko surowe (10,4%)"
  // - dopuszczały różne "surowe/surowy"
  // - dopuszczały spacje/nawiasy
  const numRe = "(\\d{1,3}(?:[\\.,]\\d{1,3})?)\\s*%?";

  const protein = grab([
    new RegExp(`bia[lł]ko(?:\\s+(?:surowe|surowy|og[oó]lne))?\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`proteina\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`protein(?:\\s+crude)?\\s*[:\\(\\s]*${numRe}`, "i"),
  ]);

  const fat = grab([
    new RegExp(`t[lł]uszcz(?:\\s+(?:surowy|surowe))?\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`fat(?:\\s+crude)?\\s*[:\\(\\s]*${numRe}`, "i"),
  ]);

  const fiber = grab([
    new RegExp(`w[lł][oó]kn[oa](?:\\s+(?:surowe|surowy))?\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`b[lł]onnik(?:\\s+(?:surowy|surowe))?\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`fiber(?:\\s+crude)?\\s*[:\\(\\s]*${numRe}`, "i"),
  ]);

  const ash = grab([
    new RegExp(`popi[oó][lł](?:\\s+(?:surowy|surowe))?\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`substancje\\s+mineralne\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`ash(?:\\s+crude)?\\s*[:\\(\\s]*${numRe}`, "i"),
  ]);

  const moisture = grab([
    new RegExp(`wilgotno[sś][cć]\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`woda\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`moisture\\s*[:\\(\\s]*${numRe}`, "i"),
  ]);

  const calcium = grab([
    new RegExp(`wap[nń](?:\\s+|:|\\()*(?:ca)?\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`\\bca\\b\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`calcium\\s*[:\\(\\s]*${numRe}`, "i"),
  ]);

  const phosphorus = grab([
    new RegExp(`fosfor(?:\\s+|:|\\()*(?:p)?\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`\\bp\\b\\s*[:\\(\\s]*${numRe}`, "i"),
    new RegExp(`phosphorus\\s*[:\\(\\s]*${numRe}`, "i"),
  ]);

  return {
    protein,
    fat,
    fiber,
    ash,
    moisture,
    calcium,
    phosphorus
  };
}


  function handleLoadAnalytic() {
    clearInvalid();

    const parsed = parseAnalyticText(f.analyticText ? f.analyticText.value : "");
    if (!parsed) {
      alertAnalytic("warn", "Nie udało się rozpoznać danych ze składu analitycznego. Wklej wartości z % (np. białko 11,9%).");
      return;
    }

  // uzupełnij pola tylko jeśli parser coś znalazł
  const setIf = (id, v) => {
    if (v == null) return;
    const el = document.getElementById(id);
    if (!el) return;
    el.value = String(v).replace(".", ","); // UI PL
    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  };

  setIf("protein", parsed.protein);
  setIf("fat", parsed.fat);
  setIf("fiber", parsed.fiber);
  setIf("ash", parsed.ash);
  setIf("moisture", parsed.moisture);
  setIf("calcium", parsed.calcium);
  setIf("phosphorus", parsed.phosphorus);

    alertAnalytic("ok", "Wczytano skład analityczny i uzupełniono pola, które udało się rozpoznać.");
  }

  // ====== ANALIZA "ZWYKŁEGO SKŁADU" (opcjonalna) ======
  // Prosta heurystyka na 3 klasy:
  // A - dobra / B - średnia / C - słaba
  // Bez procentów działa orientacyjnie, z procentami jest sensowniejsza.
  //
  // Zasada: ignorujemy liczby wewnątrz "w tym: 50% ..." jako rozbicie składnika,
  // nie doliczamy ich drugi raz do sumy.
  function normalizeIngredientsText(text) {
    return String(text || "")
      .replace(/\r/g, "\n")
      .replace(/;/g, ",")
      .replace(/\s+/g, " ")
      .trim();
  }

  function stripNestedBreakdown(text) {
    // Usuwa fragmenty "(w tym: ...)" z wnętrza, żeby nie podwajać procentów
    return text.replace(/\(\s*w tym\s*:[^)]+\)/gi, "");
  }

  function extractPercentItems(text) {
    // wyciąga pary: "nazwa ... 55%" lub "55% nazwa"
    // zwraca listę obiektów: {name, pct}
    const cleaned = stripNestedBreakdown(text);
    const items = [];

    // 1) "55% coś"
    const rx1 = /(\d+(?:[.,]\d+)?)\s*%\s*([^,]+)/g;
    let m;
    while ((m = rx1.exec(cleaned)) !== null) {
      const pct = toNumber(m[1]);
      const name = (m[2] || "").trim();
      if (pct != null && name) items.push({ name, pct });
    }

    // 2) "coś 55%"
    const rx2 = /([^,]+?)\s*(\d+(?:[.,]\d+)?)\s*%/g;
    while ((m = rx2.exec(cleaned)) !== null) {
      const name = (m[1] || "").trim();
      const pct = toNumber(m[2]);
      // unikamy dubli z rx1 (gdy tekst pasuje do obu)
      if (pct != null && name && !items.some((x) => x.pct === pct && x.name === name)) {
        items.push({ name, pct });
      }
    }

    return items;
  }

  function classifyIngredient(name) {
    const n = name.toLowerCase();

    // bulion/woda
    if (/(bulion|ros[oó]ł|woda)/.test(n)) return "broth";

    // ogólne zwierzęce (nieprecyzyjne)
    if (/(produk(t|tów)\s+zwierz(ę|e)cych|pochodzenia\s+zwierz(ę|e)cego|mi[eę]so\s+i\s+produkty\s+zwierz)/.test(n)) {
      return "vague_animal";
    }

    // mięso mięśniowe
    if (/(pier[sś]|filet|\bmi[eę]so\s+mi[eę][sś]niow\w*|\bmi[eę]s\w*\b)/.test(n)) return "meat";


    // podroby/narządy
    if (/(?:^|[^\p{L}])(podrob\w*|narz[aą]d\w*|w[aą]trob\w*|serc\w*|p[łl]uc\w*|tchawic\w*|krtan\w*|prze[yłl]yk\w*|żo[łl][aą]dk\w*|nerk\w*|śledzion\w*)(?:$|[^\p{L}])/.test(n)) {
      return "offal";
    }


    // wypełniacze / tanie dodatki
    if (/(zboż|pszenic|kukurydz|ryż|soja|białko\s+sojowe|gluten|skrobi|m[aą]ka\s+grochowa|groch|tapiok|ziemniaczan|lignoceluloz)/.test(n)) {
      return "filler";
    }

    // warzywa/owoce/zioła (neutralne)
    if (/(marchew|broku[łl]|szpinak|bor[oó]wk|dyni|jab[łl]k|inulin|zio[łl]|oregano|kurkum|ostropest|pokrzyw|dzika\s+r[oó]ż|yucca|spirulin|algi|chia|si[eę]mi[eę]\s+lnian)/.test(n)) {
      return "plant";
    }

    // minerały / witaminy
    if (/(minera[łl]|witam)/.test(n)) return "supplements";

    return "other";
  }

  function analyzeIngredients(text) {
  if (!f.ingredientsText || !out.alertsIngredients) return;

  out.alertsIngredients.innerHTML = "";

  const t0 = normalizeIngredientsText(text);
  if (!t0) {
    alertIngredients("warn", "Wklej skład z listą składników, żeby uruchomić jego ocenę. Pole jest niżej, zaznaczyliśmy je.");
    pointToIngredients();
    return;
  }

  const lower = t0.toLowerCase();

  // flagi "czerwone"
  const hasVagueAnimal =
    /(produk(t|tów)\s+(pochodzenia\s+)?zwierz(ę|e)cego|mi[eę]so\s+i\s+produkty\s+zwierz|pochodzenia\s+zwierz(ę|e)cego)/.test(lower);

  const hasGrainsOrSugars =
    /(zboż|pszenic|kukurydz|ryż|owies|jęczmień|cukry|roślinne\s+ekstrakty\s+białkowe|ekstrakty\s+białkowe)/.test(lower);

  const hasPea =
    /(groch|skrobi[aą]\s*groch|b[łl]onnik\s*groch|białko\s*groch|m[aą]ka\s*groch)/.test(lower);

  const items = extractPercentItems(t0); // już ignoruje "(w tym: ...)" przez stripNestedBreakdown()

  // Jeżeli mamy procenty, liczymy sensownie
  let meatPct = 0;
  let offalPct = 0;
  let mixedAnimalPct = 0;
  let vagueAnimalPct = 0;
  let brothPct = 0;
  let fillerPct = 0;
  let peaPct = 0;

  if (items.length) {
    for (const it of items) {
      const cls = classifyIngredient(it.name);
      if (cls === "meat") meatPct += it.pct;
      else if (cls === "offal") offalPct += it.pct;
      else if (cls === "mixed_animal") mixedAnimalPct += it.pct; // „mięso i narządy”
      else if (cls === "vague_animal") vagueAnimalPct += it.pct; // „produkty pochodzenia zwierzęcego”
      else if (cls === "broth") brothPct += it.pct;
      else if (cls === "pea_warning") peaPct += it.pct;
      else if (cls === "filler") fillerPct += it.pct;
    }

    const totalAnimal = meatPct + offalPct + mixedAnimalPct + vagueAnimalPct;

    // Jeśli wyszło 0% zwierzęcych, traktujemy jako błąd formatu
    if (totalAnimal <= 0.0001) {
      alertIngredients(
        "warn",
        "Niestety nie udało nam się przeanalizować składu w formacie jakim napisał go producent. Jeśli możesz spróbuj napisać % ile jest mięsa, podrobów i spróbuj ponownie."
      );
      return;
    }

    // Mięsność < 20% -> czerwono (twardy próg)
    if (totalAnimal < 20) {
      alertIngredients("bad", `Szacowana mięsność (mięso + podroby): ~${Math.round(totalAnimal)}% (bardzo nisko).`);
      alertIngredients("bad", "Wykryto poniżej 20% składników zwierzęcych. Taki skład zwykle oznacza niską jakość.");
      return; // zgodnie z Twoją intencją: czerwono i dość jasne, reszta mniej istotna
    }

    // Informacyjne podsumowanie
    const meatLike = meatPct + mixedAnimalPct; // „mięso” + „mięso i narządy”
    alertIngredients("ok", `Szacowana mięsność (mięso + podroby): ~${Math.round(totalAnimal)}%.`);
    alertIngredients("ok", `Udział mięsa (w tym „mięso i narządy”): ~${Math.round(meatLike)}%, podroby: ~${Math.round(offalPct)}%.`);

    if (brothPct > 0) {
      // bulion oceniaj lepiej: część wilgoci w mokrej karmie jest naturalna
      if (brothPct >= 15) alertIngredients("ok", `Bulion/woda: ~${Math.round(brothPct)}% (typowe dla mokrej karmy, OK).`);
      else alertIngredients("ok", `Bulion/woda: ~${Math.round(brothPct)}%.`);
    }

    // Ostrzeżenia
    if (peaPct > 0 || hasPea) {
      alertIngredients("warn", "Wykryto dodatek grochu (np. skrobia/błonnik/białko grochowe). U części psów może pogarszać strawność lub zwiększać udział węglowodanów.");
    }

    if (mixedAnimalPct > 0) {
      alertIngredients("warn", "W składzie jest zapis typu „mięso i narządy/podroby” bez doprecyzowania. To mniej transparentne niż rozpisane narządy (np. wątroba/serca/płuca).");
    }

    if (vagueAnimalPct > 0 || hasVagueAnimal) {
      alertIngredients("bad", "Wykryto nieprecyzyjne określenia typu „produkty pochodzenia zwierzęcego”. To duży minus dla jakości i transparentności.");
    }

    if (fillerPct > 0 || hasGrainsOrSugars) {
      // tu ostrzej: zboża/cukry/roślinne ekstrakty białkowe
      if (/(cukry|roślinne\s+ekstrakty\s+białkowe|ekstrakty\s+białkowe)/.test(lower)) {
        alertIngredients("bad", "Wykryto cukry i/lub roślinne ekstrakty białkowe. To częsty sygnał mocno „taniego” składu.");
      } else {
        alertIngredients("warn", "Wykryto zboża/skrobie/wypełniacze. To może obniżać jakość i zwiększać udział węglowodanów.");
      }
    }

    // ===== Ocena 3-klasowa =====
    // A: dużo zwierzęcych, brak vague, brak grochu i brak fillerów
    // B (żółto): ogólnie ok, ale są ostrzeżenia (groch, mixed_animal, niewielkie fillery)
    // C (czerwono): vague + zboża/cukry/ekstrakty albo bardzo niska mięsność
    let grade = "B";

    const isRed =
      (hasVagueAnimal || vagueAnimalPct > 0) &&
      (hasGrainsOrSugars || fillerPct > 0);

    if (isRed) grade = "C";
    else {
      const isA =
        totalAnimal >= 65 &&
        (vagueAnimalPct === 0 && !hasVagueAnimal) &&
        (peaPct === 0 && !hasPea) &&
        (fillerPct === 0 && !hasGrainsOrSugars) &&
        (mixedAnimalPct === 0); // pełna transparentność
      grade = isA ? "A" : "B";
    }

    if (grade === "A") {
      alertIngredients("ok", "Ocena składu: A (wysoka jakość) – dużo składników zwierzęcych i dobra transparentność.");
    } else if (grade === "B") {
      alertIngredients("warn", "Ocena składu: B (średnia) – skład ogólnie OK, ale są elementy obniżające jakość/transparentność (np. groch, „mięso i narządy”, skrobie).");
    } else {
      alertIngredients("bad", "Ocena składu: C (słaba) – nieprecyzyjne „produkty zwierzęce” + zboża/cukry/ekstrakty białkowe to duży minus.");
    }

    return;
  }

  // ===== Brak procentów: tylko heurystyka po słowach =====
  // Tu nie wyliczamy mięsności, tylko oceniamy jakość zapisu
  if (hasVagueAnimal && hasGrainsOrSugars) {
    alertIngredients("bad", "Ocena składu: C (słaba) – nieprecyzyjne „produkty pochodzenia zwierzęcego” + zboża/cukry/ekstrakty białkowe.");
    return;
  }

  if (hasPea) alertIngredients("warn", "Wykryto groch (np. skrobia/błonnik/białko grochowe) – ostrzeżenie.");
  if (/(mi[eę]so\s+i\s+narz[aą]dy|mi[eę]so\s+i\s+podroby)/.test(lower)) {
    alertIngredients("warn", "Wykryto zapis „mięso i narządy/podroby” bez doprecyzowania – mniejsza transparentność.");
  }
  if (hasGrainsOrSugars) alertIngredients("warn", "Wykryto zboża/skrobie/cukry – może obniżać jakość.");

  if (!hasVagueAnimal && !hasGrainsOrSugars && !hasPea) {
    alertIngredients("ok", "Skład wygląda na dość transparentny (brak oczywistych czerwonych flag).");
    alertIngredients("warn", "Brak procentów utrudnia policzenie mięsności – jeśli możesz, wklej wersję z %.");
  } else {
    alertIngredients("warn", "Ocena składu: B (średnia) – są elementy, które mogą obniżać jakość lub strawność.");
  }
}


  // ====== GŁÓWNE OBLICZENIA ======
  function calc() {
    clearUI();

    const stage = f.lifeStage && f.lifeStage.value === "puppy" ? "puppy" : "adult";

    const p = toNumber(f.protein.value);
    const fa = toNumber(f.fat.value);
    const fi = toNumber(f.fiber.value);
    const a = toNumber(f.ash.value);
    const m = toNumber(f.moisture.value);

    const ca = toNumber(f.calcium ? f.calcium.value : null);
    const ph = toNumber(f.phosphorus ? f.phosphorus.value : null);

    // Walidacja wymaganych
    let ok = true;
    if (p === null) { markInvalid(f.protein); ok = false; }
    if (fa === null) { markInvalid(f.fat); ok = false; }
    if (fi === null) { markInvalid(f.fiber); ok = false; }
    if (m === null) { markInvalid(f.moisture); ok = false; }

    if (!ok) {
      alertAnalytic("bad", "Uzupełnij wymagane pola: białko, tłuszcz, włókno i wilgotność.");
      return;
    }

    const dm = 100 - m;
    if (dm <= 0 || dm > 100) {
      markInvalid(f.moisture);
      alertAnalytic("bad", "Nieprawidłowa wilgotność (DM musi być w zakresie 0–100%).");
      return;
    }

    // Popiół bywa nieczytelny na etykiecie albo w ogóle go tam nie ma. Bez niego
    // nie domknie się bilans, więc przyjmujemy typową wartość dla danego typu karmy
    // i oznaczamy zależne wyniki jako przybliżone. Sucha masa oraz białko, tłuszcz
    // i włókno w suchej masie pozostają dokładne, bo nie zależą od popiołu.
    const ashEstimated = a === null;
    const ashUsed = ashEstimated ? (m >= 60 ? 2 : m >= 20 ? 4 : 7) : a;

    const carbs = 100 - p - fa - fi - ashUsed - m;
    if (carbs < -1) {
      alertAnalytic("bad", "Suma składników przekracza 100%. Sprawdź wpisane wartości.");
      return;
    }

    const pDm = (p / dm) * 100;
    const fDm = (fa / dm) * 100;
    const fiDm = (fi / dm) * 100;
    const cDm = (Math.max(0, carbs) / dm) * 100;

    const caDm = ca !== null ? (ca / dm) * 100 : null;
    const phDm = ph !== null ? (ph / dm) * 100 : null;
    const capRatio = ca !== null && ph !== null && ph > 0 ? ca / ph : null;

    // ME kcal/100g – modified Atwater 3.5/8.5/3.5
    const meKcal100 = 3.5 * (p + Math.max(0, carbs)) + 8.5 * fa;

    // Wyniki
    out.carbs.textContent = (ashEstimated ? "≈ " : "") + pct(cDm);
    out.protein.textContent = pct(pDm);
    out.fat.textContent = pct(fDm);
    out.fiber.textContent = pct(fiDm);
    out.kcal.textContent = (ashEstimated ? "≈ " : "") + kcalFmt(meKcal100);
    out.dm.textContent = pct(dm);

    out.calcium.textContent = caDm === null ? "–" : pct(caDm);
    out.phosphorus.textContent = phDm === null ? "–" : pct(phDm);
    out.cap.textContent = capRatio === null ? "–" : capRatio.toFixed(2);

    // Badge info
    const T = getThresholds(stage, m);

    badge("ok", "Etap: " + (stage === "puppy" ? "Szczeniak" : "Dorosły"));
    badge("ok", "Typ: " + (T.isWet ? "mokra" : "sucha"));

    if (ashEstimated) {
      badge("warn", "Popiół: szacowany");
      alertAnalytic(
        "warn",
        "Bez popiołu przyjęliśmy typową wartość " + String(ashUsed).replace(".", ",") +
        "% dla karmy " + (T.isWet ? "mokrej" : "suchej") +
        ". Sucha masa oraz białko, tłuszcz i włókno są policzone dokładnie. Węglowodany i kaloryczność są przybliżone, oznaczyliśmy je znakiem ≈. Wpisz popiół z etykiety, żeby dostać dokładny wynik."
      );
    }

    // ===== Oceny analityczne =====
    // Tłuszcz DM: 28–35 warn, >35 bad
    if (fDm > 35) {
      badge("bad", "Tłuszcz: bardzo wysoki");
      alertAnalytic("bad", "Tłuszcz jest bardzo wysoki. Tę karmę zalecamy stosować jedynie jako uzupełnienie diety.");
    } else if (fDm >= 28) {
      badge("warn", "Tłuszcz: wysoki");
      alertAnalytic("warn", "Ta karma ma wysoką zawartość tłuszczu i może nie nadawać się do podawania na co dzień.");
    } else {
      badge("ok", "Tłuszcz: OK");
    }

    // Kaloryczność
    if (meKcal100 >= T.kcal.high) {
      badge("warn", "Kaloryczność: wysoka");
      alertAnalytic("warn", "To karma wysokokaloryczna względem progów dla wybranego etapu życia.");
    } else if (meKcal100 <= T.kcal.low) {
      badge("warn", "Kaloryczność: niska");
      alertAnalytic("warn", "To karma niskokaloryczna względem progów dla wybranego etapu życia.");
    } else {
      badge("ok", "Kaloryczność: OK");
    }

    // Ca:P
    if (capRatio !== null) {
      if (capRatio < T.cap.warnMin) {
        badge("bad", "Ca:P: zbyt niski");
        alertAnalytic("bad", "Stosunek Ca:P jest zbyt niski dla wybranego etapu życia.");
      } else if (capRatio > T.cap.warnMax) {
        badge("bad", "Ca:P: zbyt wysoki");
        alertAnalytic("bad", "Stosunek Ca:P jest zbyt wysoki dla wybranego etapu życia.");
      } else if (capRatio < T.cap.okMin || capRatio > T.cap.okMax) {
        badge("warn", "Ca:P: graniczny");
        alertAnalytic("warn", "Stosunek Ca:P jest graniczny. Dla szczeniaka szczególnie warto być bliżej środka widełek.");
      } else {
        badge("ok", "Ca:P: OK");
      }
    } else {
      badge("warn", "Ca:P: brak danych");
      alertAnalytic("warn", "Nie podano wapnia i/lub fosforu, więc nie da się ocenić Ca:P.");
    }

    // Węglowodany DM: podpowiedź (neutralna)
    if (cDm > 45) badge("warn", "Węglowodany: wysokie");
    else if (cDm < 25) badge("ok", "Węglowodany: niskie");
    else badge("ok", "Węglowodany: typowe");

    // Pozytywny komunikat jeśli brak warn/bad w analizie analitycznej
    const hasBadA = out.badges.querySelector(".hn-badge.bad") || out.alertsAnalytic.querySelector(".hn-alert.bad");
    const hasWarnA = out.badges.querySelector(".hn-badge.warn") || out.alertsAnalytic.querySelector(".hn-alert.warn");
    if (!hasBadA && !hasWarnA) {
      alertAnalytic(
        "ok",
        "Karma wygląda na dobrze zbilansowaną. Tłuszcz i białko są na odpowiednim poziomie, a parametry mieszczą się w typowych widełkach. Może być stosowana do podawania na co dzień."
      );
    }

    // ===== Analiza zwykłego składu (jeśli pole istnieje) =====
    if (f.ingredientsText) {
      analyzeIngredients(f.ingredientsText.value);
    } else {
      // jeśli pola nie ma, pokaż delikatną wskazówkę (albo usuń tę linijkę jeśli nie chcesz)
      // alertIngredients("warn","Brak pola „Skład” w HTML (id=ingredientsText) – analiza składu jest wyłączona.");
    }
  }

  // ====== EVENTS ======
  // Bottom „Oblicz" — jeśli textarea analityki ma treść, najpierw ją sparsuj i uzupełnij
  // pola manualne (overwrite — analityka ma pierwszeństwo, bo jest "shortcut"), potem licz.
  // Jeśli textarea analityki pusta, działa jak czyste manual calc.
  $("btnCalc").addEventListener("click", () => {
    out.alertsAnalytic.innerHTML = "";
    const analyticVal = f.analyticText ? f.analyticText.value.trim() : "";
    if (analyticVal) {
      handleLoadAnalytic();
    }
    calc();
  });

  $("btnClear").addEventListener("click", () => {
    // nie czyścimy lifeStage? czyścimy na dorosły
    if (f.lifeStage) f.lifeStage.value = "adult";
    if (f.analyticText) f.analyticText.value = "";
    if (f.protein) f.protein.value = "";
    if (f.fat) f.fat.value = "";
    if (f.fiber) f.fiber.value = "";
    if (f.ash) f.ash.value = "";
    if (f.moisture) f.moisture.value = "";
    if (f.calcium) f.calcium.value = "";
    if (f.phosphorus) f.phosphorus.value = "";
    if (f.ingredientsText) f.ingredientsText.value = "";
    clearUI();
  });

  if (f.btnLoadAnalytic) {
    f.btnLoadAnalytic.addEventListener("click", () => {
      // nie czyścimy wszystkich wyników, ale czyścimy komunikaty analityczne aby “Wczytano” było widoczne
      out.alertsAnalytic.innerHTML = "";
      handleLoadAnalytic();
    });
  }

  // usuwaj czerwone obramowania gdy user zaczyna pisać
  if (f.ingredientsText) {
    f.ingredientsText.addEventListener("input", () => {
      f.ingredientsText.classList.remove("hn-attention");
    });
  }

  const requiredInputs = [f.protein, f.fat, f.fiber, f.ash, f.moisture];
  requiredInputs.forEach((el) => {
    if (!el) return;
    el.addEventListener("input", () => el.classList.remove("hn-invalid"));
  });

  // Taby trybów wejścia — "Wklej analitykę" vs "Wpisz ręcznie".
  // Toggle widoczności paneli; logika obliczeń niezależna (czyta pola z DOM
  // niezależnie od tego który panel jest widoczny).
  const dmTabs = document.querySelectorAll("[data-hn-dm-tab]");
  const dmPanels = document.querySelectorAll("[data-hn-dm-panel]");
  dmTabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const target = tab.getAttribute("data-hn-dm-tab");
      dmTabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle("is-active", active);
        t.setAttribute("aria-selected", active ? "true" : "false");
      });
      dmPanels.forEach((p) => {
        p.hidden = p.getAttribute("data-hn-dm-panel") !== target;
      });
    });
  });

  clearUI();
}
